'use client';

import { css, FlattenSimpleInterpolation } from 'styled-components';

import { minWidth } from '../mediaQueries';
import { FontSizes, MobileFontSizes, type FontSize, type FontSizeName, type FontWeight } from './types';

export const fontSize = (size: FontSize): FlattenSimpleInterpolation => {
	const fontSizeKey = (Object.keys(FontSizes) as FontSizeName[]).find(k => FontSizes[k] === size);
	const mobileFontSizeValue = fontSizeKey ? MobileFontSizes[fontSizeKey] : undefined;

	return css`
		font-size: ${mobileFontSizeValue ?? size}rem;
		${minWidth('mobileLarge')} {
			font-size: ${size * 1.125}rem;
		}
	`;
};

// These line heights are the closest to our "usual" 1.5 that put R18 fonts on an 8px grid
export const R18LineHeightsByFontSize: Record<FontSize, string> = {
	[FontSizes.sm]: '20px',
	[FontSizes.base]: '28px',
	[FontSizes.lg]: '32px',
	[FontSizes.xl]: '40px',
	[FontSizes['2xl']]: '48px',
	[FontSizes['3xl']]: '60px',
	[FontSizes['4xl']]: '72px',
} as const;
export const lineHeight = (size: FontSize): FlattenSimpleInterpolation => css`
	line-height: 150%;
	${minWidth('mobileLarge')} {
		line-height: ${R18LineHeightsByFontSize[size]};
	}
`;

export const fontWeight = (weight: FontWeight): FlattenSimpleInterpolation => css`
	font-weight: ${weight};
`;

export const fontFamily = css`
	font-family: 'Figtree', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
`;

export const themeFontFamily = (fontFamily: string): FlattenSimpleInterpolation => css`
	font-family: ${fontFamily}, 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
`;
